import { Environments, PartialServiceMap } from '@innovyze/lib_get_service';

const config: PartialServiceMap = {
	// Sample config for overwritting service endpoints
	[Environments.LOCAL]: {
		assets: 'https://saas-asset-management.info360-dev.com/dev',
		amInspection: 'https://saas-inspection-management.info360-dev.com/dev',
		saasAmRehab: 'https://saas-am-rehab.wlc360a-c-uw2.autodesk.com/dev',
		saasPipeDeterioration: 'https://saas-water-ai-pipe-deterioration.wlc360ai-c-uw2.autodesk.com/dev',
	},
};

export const apiEnv = (localStorage.getItem('apiEnv') as keyof typeof Environments) || undefined;

export default config;
